import {
    UNLOCKETREQUEST_SUCCESSFUL_GET
} from 'reducers/constants';


const initialState = {
    data: null,
    filterStatus: null,
    filterStartDate: "",
    filterEndDate: "",
    info: null,
    history: []
}

export default function (state = initialState, action) {
    switch (action.type) {
        case UNLOCKETREQUEST_SUCCESSFUL_GET:
            return {
                ...state,
                data: Object.assign({}, action.payload)
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/unlockrequest/unlockrequestReducer.js